import React from 'react';
import { Route, Routes, useMatch } from 'react-router';
import { Link } from 'react-router-dom';
import { Iteration, IterString } from '../../components/ccmExercise';
import {StyledCCM, StyledCcmList} from './styled'
import { RoutePath } from '../../router/RoutePath';

export const CcmExercises = () => {
  let match = useMatch(RoutePath.CcmExercises); // Adjust if your route is different
  let basePath = match?.pathnameBase || RoutePath.CcmExercises;

  return (
    <StyledCCM>
      <Routes>
        <Route 
          path="/" 
          element={
            <StyledCcmList>
              CCM Exercises
              <ul>
                <li><Link to={`${basePath}/iteration`}>iteration</Link></li>
                <li><Link to={`${basePath}/iter-string`}>iteration string</Link></li>
              </ul>
            </StyledCcmList>
          } 
        />
        <Route path="iteration" element={<Iteration />} />
        <Route path="iter-string" element={<IterString />} />
      </Routes>
    </StyledCCM>
  )
}